import * as actions from './actions';
import * as getters from './getters';

import { SET_HAS_LEAD_STATUS, SET_LEAD_EXPERIENCE, SET_LEAD_EXPERIMENTS, SET_LEAD_UUID } from '../mutation-types';

const mutations = {
  [SET_HAS_LEAD_STATUS](state, payload) {
    state.lead = payload;
  },
  [SET_LEAD_UUID](state, payload) {
    state.uuid = payload;
  },
  [SET_LEAD_EXPERIMENTS](state, experiments) {
    state.experiments = experiments;
  },
  [SET_LEAD_EXPERIENCE](state, experience) {
    state.experience = experience;
  },
};

const state = () => ({
  lead: null,
  uuid: null,
  experiments: {},
  experience: {},
});

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};
